// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: order.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Exchange, exchangeFromJSON, exchangeToJSON } from "./common";
import { Condition } from "./nexus";
import { OptionType, optionTypeFromJSON, optionTypeToJSON } from "./security";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.order";

export enum OrderType {
  ORDER_TYPE_UNKNOWN = 0,
  NORMAL = 1,
  STOP_LOSS = 2,
  TARGET = 4,
  TRIGGER = 5,
  ICEBERG = 6,
  CONDITIONAL_ENTRY = 7,
  CONDITIONAL_EXIT = 8,
  UNRECOGNIZED = -1,
}

export function orderTypeFromJSON(object: any): OrderType {
  switch (object) {
    case 0:
    case "ORDER_TYPE_UNKNOWN":
      return OrderType.ORDER_TYPE_UNKNOWN;
    case 1:
    case "NORMAL":
      return OrderType.NORMAL;
    case 2:
    case "STOP_LOSS":
      return OrderType.STOP_LOSS;
    case 4:
    case "TARGET":
      return OrderType.TARGET;
    case 5:
    case "TRIGGER":
      return OrderType.TRIGGER;
    case 6:
    case "ICEBERG":
      return OrderType.ICEBERG;
    case 7:
    case "CONDITIONAL_ENTRY":
      return OrderType.CONDITIONAL_ENTRY;
    case 8:
    case "CONDITIONAL_EXIT":
      return OrderType.CONDITIONAL_EXIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrderType.UNRECOGNIZED;
  }
}

export function orderTypeToJSON(object: OrderType): string {
  switch (object) {
    case OrderType.ORDER_TYPE_UNKNOWN:
      return "ORDER_TYPE_UNKNOWN";
    case OrderType.NORMAL:
      return "NORMAL";
    case OrderType.STOP_LOSS:
      return "STOP_LOSS";
    case OrderType.TARGET:
      return "TARGET";
    case OrderType.TRIGGER:
      return "TRIGGER";
    case OrderType.ICEBERG:
      return "ICEBERG";
    case OrderType.CONDITIONAL_ENTRY:
      return "CONDITIONAL_ENTRY";
    case OrderType.CONDITIONAL_EXIT:
      return "CONDITIONAL_EXIT";
    case OrderType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Product {
  PRODUCT_UNKNOWN = 0,
  CNC = 1,
  INTRADAY = 2,
  MARGIN = 3,
  MTF = 4,
  UNRECOGNIZED = -1,
}

export function productFromJSON(object: any): Product {
  switch (object) {
    case 0:
    case "PRODUCT_UNKNOWN":
      return Product.PRODUCT_UNKNOWN;
    case 1:
    case "CNC":
      return Product.CNC;
    case 2:
    case "INTRADAY":
      return Product.INTRADAY;
    case 3:
    case "MARGIN":
      return Product.MARGIN;
    case 4:
    case "MTF":
      return Product.MTF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Product.UNRECOGNIZED;
  }
}

export function productToJSON(object: Product): string {
  switch (object) {
    case Product.PRODUCT_UNKNOWN:
      return "PRODUCT_UNKNOWN";
    case Product.CNC:
      return "CNC";
    case Product.INTRADAY:
      return "INTRADAY";
    case Product.MARGIN:
      return "MARGIN";
    case Product.MTF:
      return "MTF";
    case Product.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Validity {
  VALIDITY_UNKNOWN = 0,
  DAY = 1,
  IOC = 2,
  TTL = 3,
  GTT = 4,
  UNRECOGNIZED = -1,
}

export function validityFromJSON(object: any): Validity {
  switch (object) {
    case 0:
    case "VALIDITY_UNKNOWN":
      return Validity.VALIDITY_UNKNOWN;
    case 1:
    case "DAY":
      return Validity.DAY;
    case 2:
    case "IOC":
      return Validity.IOC;
    case 3:
    case "TTL":
      return Validity.TTL;
    case 4:
    case "GTT":
      return Validity.GTT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Validity.UNRECOGNIZED;
  }
}

export function validityToJSON(object: Validity): string {
  switch (object) {
    case Validity.VALIDITY_UNKNOWN:
      return "VALIDITY_UNKNOWN";
    case Validity.DAY:
      return "DAY";
    case Validity.IOC:
      return "IOC";
    case Validity.TTL:
      return "TTL";
    case Validity.GTT:
      return "GTT";
    case Validity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TransactionType {
  TRANSACTION_TYPE_UNKNOWN = 0,
  BUY = 1,
  SELL = 2,
  MIXED = 3,
  UNRECOGNIZED = -1,
}

export function transactionTypeFromJSON(object: any): TransactionType {
  switch (object) {
    case 0:
    case "TRANSACTION_TYPE_UNKNOWN":
      return TransactionType.TRANSACTION_TYPE_UNKNOWN;
    case 1:
    case "BUY":
      return TransactionType.BUY;
    case 2:
    case "SELL":
      return TransactionType.SELL;
    case 3:
    case "MIXED":
      return TransactionType.MIXED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransactionType.UNRECOGNIZED;
  }
}

export function transactionTypeToJSON(object: TransactionType): string {
  switch (object) {
    case TransactionType.TRANSACTION_TYPE_UNKNOWN:
      return "TRANSACTION_TYPE_UNKNOWN";
    case TransactionType.BUY:
      return "BUY";
    case TransactionType.SELL:
      return "SELL";
    case TransactionType.MIXED:
      return "MIXED";
    case TransactionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum OrderStatus {
  ORDER_STATUS_UNKNOWN = 0,
  INACTIVE = 1,
  TRIGGER_PENDING = 3,
  PENDING = 2,
  FAILED = 4,
  OPEN = 6,
  REJECTED = 8,
  PARTIALLY_FILLED = 10,
  EXECUTED = 12,
  CANCELLED = 14,
  UNRECOGNIZED = -1,
}

export function orderStatusFromJSON(object: any): OrderStatus {
  switch (object) {
    case 0:
    case "ORDER_STATUS_UNKNOWN":
      return OrderStatus.ORDER_STATUS_UNKNOWN;
    case 1:
    case "INACTIVE":
      return OrderStatus.INACTIVE;
    case 3:
    case "TRIGGER_PENDING":
      return OrderStatus.TRIGGER_PENDING;
    case 2:
    case "PENDING":
      return OrderStatus.PENDING;
    case 4:
    case "FAILED":
      return OrderStatus.FAILED;
    case 6:
    case "OPEN":
      return OrderStatus.OPEN;
    case 8:
    case "REJECTED":
      return OrderStatus.REJECTED;
    case 10:
    case "PARTIALLY_FILLED":
      return OrderStatus.PARTIALLY_FILLED;
    case 12:
    case "EXECUTED":
      return OrderStatus.EXECUTED;
    case 14:
    case "CANCELLED":
      return OrderStatus.CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrderStatus.UNRECOGNIZED;
  }
}

export function orderStatusToJSON(object: OrderStatus): string {
  switch (object) {
    case OrderStatus.ORDER_STATUS_UNKNOWN:
      return "ORDER_STATUS_UNKNOWN";
    case OrderStatus.INACTIVE:
      return "INACTIVE";
    case OrderStatus.TRIGGER_PENDING:
      return "TRIGGER_PENDING";
    case OrderStatus.PENDING:
      return "PENDING";
    case OrderStatus.FAILED:
      return "FAILED";
    case OrderStatus.OPEN:
      return "OPEN";
    case OrderStatus.REJECTED:
      return "REJECTED";
    case OrderStatus.PARTIALLY_FILLED:
      return "PARTIALLY_FILLED";
    case OrderStatus.EXECUTED:
      return "EXECUTED";
    case OrderStatus.CANCELLED:
      return "CANCELLED";
    case OrderStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SecondaryOrderStatus {
  SECONDARY_ORDER_STATUS_UNKNOWN = 0,
  SYNC_DEFERRED = 1,
  SYNC_IN_PROGRESS = 2,
  SYNC_COMPLETED = 3,
  CANCEL_IN_PROGRESS = 7,
  MODIFY_PENDING = 4,
  MODIFIED_REJECTED = 5,
  UNRECOGNIZED = -1,
}

export function secondaryOrderStatusFromJSON(object: any): SecondaryOrderStatus {
  switch (object) {
    case 0:
    case "SECONDARY_ORDER_STATUS_UNKNOWN":
      return SecondaryOrderStatus.SECONDARY_ORDER_STATUS_UNKNOWN;
    case 1:
    case "SYNC_DEFERRED":
      return SecondaryOrderStatus.SYNC_DEFERRED;
    case 2:
    case "SYNC_IN_PROGRESS":
      return SecondaryOrderStatus.SYNC_IN_PROGRESS;
    case 3:
    case "SYNC_COMPLETED":
      return SecondaryOrderStatus.SYNC_COMPLETED;
    case 7:
    case "CANCEL_IN_PROGRESS":
      return SecondaryOrderStatus.CANCEL_IN_PROGRESS;
    case 4:
    case "MODIFY_PENDING":
      return SecondaryOrderStatus.MODIFY_PENDING;
    case 5:
    case "MODIFIED_REJECTED":
      return SecondaryOrderStatus.MODIFIED_REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SecondaryOrderStatus.UNRECOGNIZED;
  }
}

export function secondaryOrderStatusToJSON(object: SecondaryOrderStatus): string {
  switch (object) {
    case SecondaryOrderStatus.SECONDARY_ORDER_STATUS_UNKNOWN:
      return "SECONDARY_ORDER_STATUS_UNKNOWN";
    case SecondaryOrderStatus.SYNC_DEFERRED:
      return "SYNC_DEFERRED";
    case SecondaryOrderStatus.SYNC_IN_PROGRESS:
      return "SYNC_IN_PROGRESS";
    case SecondaryOrderStatus.SYNC_COMPLETED:
      return "SYNC_COMPLETED";
    case SecondaryOrderStatus.CANCEL_IN_PROGRESS:
      return "CANCEL_IN_PROGRESS";
    case SecondaryOrderStatus.MODIFY_PENDING:
      return "MODIFY_PENDING";
    case SecondaryOrderStatus.MODIFIED_REJECTED:
      return "MODIFIED_REJECTED";
    case SecondaryOrderStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Broker {
}

export enum Broker_Variety {
  VARIETY_UNKNOWN = 0,
  REGULAR = 1,
  AFTER_MARKET_ORDER = 2,
  COVER_ORDER = 3,
  BRACKET_ORDER = 6,
  ICEBERG_ORDER = 4,
  AUCTION_ORDER = 5,
  UNRECOGNIZED = -1,
}

export function broker_VarietyFromJSON(object: any): Broker_Variety {
  switch (object) {
    case 0:
    case "VARIETY_UNKNOWN":
      return Broker_Variety.VARIETY_UNKNOWN;
    case 1:
    case "REGULAR":
      return Broker_Variety.REGULAR;
    case 2:
    case "AFTER_MARKET_ORDER":
      return Broker_Variety.AFTER_MARKET_ORDER;
    case 3:
    case "COVER_ORDER":
      return Broker_Variety.COVER_ORDER;
    case 6:
    case "BRACKET_ORDER":
      return Broker_Variety.BRACKET_ORDER;
    case 4:
    case "ICEBERG_ORDER":
      return Broker_Variety.ICEBERG_ORDER;
    case 5:
    case "AUCTION_ORDER":
      return Broker_Variety.AUCTION_ORDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Broker_Variety.UNRECOGNIZED;
  }
}

export function broker_VarietyToJSON(object: Broker_Variety): string {
  switch (object) {
    case Broker_Variety.VARIETY_UNKNOWN:
      return "VARIETY_UNKNOWN";
    case Broker_Variety.REGULAR:
      return "REGULAR";
    case Broker_Variety.AFTER_MARKET_ORDER:
      return "AFTER_MARKET_ORDER";
    case Broker_Variety.COVER_ORDER:
      return "COVER_ORDER";
    case Broker_Variety.BRACKET_ORDER:
      return "BRACKET_ORDER";
    case Broker_Variety.ICEBERG_ORDER:
      return "ICEBERG_ORDER";
    case Broker_Variety.AUCTION_ORDER:
      return "AUCTION_ORDER";
    case Broker_Variety.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Broker_OrderType {
  ORDER_TYPE_UNKNOWN = 0,
  MARKET_ORDER = 1,
  LIMIT_ORDER = 2,
  STOPLOSS_ORDER = 3,
  STOPLOSS_MARKET_ORDER = 4,
  UNRECOGNIZED = -1,
}

export function broker_OrderTypeFromJSON(object: any): Broker_OrderType {
  switch (object) {
    case 0:
    case "ORDER_TYPE_UNKNOWN":
      return Broker_OrderType.ORDER_TYPE_UNKNOWN;
    case 1:
    case "MARKET_ORDER":
      return Broker_OrderType.MARKET_ORDER;
    case 2:
    case "LIMIT_ORDER":
      return Broker_OrderType.LIMIT_ORDER;
    case 3:
    case "STOPLOSS_ORDER":
      return Broker_OrderType.STOPLOSS_ORDER;
    case 4:
    case "STOPLOSS_MARKET_ORDER":
      return Broker_OrderType.STOPLOSS_MARKET_ORDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Broker_OrderType.UNRECOGNIZED;
  }
}

export function broker_OrderTypeToJSON(object: Broker_OrderType): string {
  switch (object) {
    case Broker_OrderType.ORDER_TYPE_UNKNOWN:
      return "ORDER_TYPE_UNKNOWN";
    case Broker_OrderType.MARKET_ORDER:
      return "MARKET_ORDER";
    case Broker_OrderType.LIMIT_ORDER:
      return "LIMIT_ORDER";
    case Broker_OrderType.STOPLOSS_ORDER:
      return "STOPLOSS_ORDER";
    case Broker_OrderType.STOPLOSS_MARKET_ORDER:
      return "STOPLOSS_MARKET_ORDER";
    case Broker_OrderType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Orders {
  orders: Order[];
}

export interface Order {
  orderDate: number;
  clientOrderId: string;
  orderId?: string | undefined;
  orderType: OrderType;
  isBasket: boolean;
  basketId?: string | undefined;
  batchId?: string | undefined;
  brokerOrderType: Broker_OrderType;
  brokerVariety: Broker_Variety;
  brokerOrderId?: string | undefined;
  security?: Security | undefined;
  product: Product;
  transactionType: TransactionType;
  validity: Validity;
  exchangeOrderId?: string | undefined;
  quantity: number;
  price: number;
  triggerPrice?: number | undefined;
  disclosedQuantity?: number | undefined;
  status?: OrderStatus | undefined;
  strategyGroup?: string | undefined;
  created?: number | undefined;
  exchangeTimestamp?: number | undefined;
  message?: string | undefined;
  filledQuantity?: number | undefined;
  unfilledQuantity?: number | undefined;
  averageTradedPrice?: number | undefined;
  metadata?: string | undefined;
  secondaryStatus?: SecondaryOrderStatus | undefined;
  marketProtection?: number | undefined;
  orderExecutionParams?: OrderExecutionParams | undefined;
  orderExecutionMetadata?: OrderExecutionMetadata | undefined;
  parentOrderId?:
    | string
    | undefined;
  /** only to execute limit orders as market orders for the given price */
  immediateExecutePaperOrder: boolean;
}

export interface OrderExecutionParams {
  trailStopLoss?: boolean | undefined;
  icebergNumberOfLegs?:
    | number
    | undefined;
  /** 1-based leg index within the iceberg batch. Orders with same batch_id and leg numbers 1..iceberg_number_of_legs form one iceberg order. */
  icebergLegNumber?: number | undefined;
  condition?: Condition | undefined;
}

export interface OrderExecutionMetadata {
  associatedAlertId?: string | undefined;
}

export interface Trade {
  tradeId: number;
  orderId: number;
  securityCode: string;
  product: Product;
  averagePrice: number;
  quantity: number;
  exchangeOrderId: number;
  transactionType: TransactionType;
  fillTimestamp: number;
  orderTimestamp: number;
  exchangeTimestamp: number;
}

export interface CalculateMarginResponse {
  totalMargin: number;
  strategyName: string;
}

export interface MarginFromBrokerRequest {
  orders: MarginFromBrokerRequest_Order[];
  tradingAccount: MarginFromBrokerRequest_TradingAccount | undefined;
}

export interface MarginFromBrokerRequest_Order {
  security: Security | undefined;
  transactionType: TransactionType;
  orderType: Broker_OrderType;
  position: number;
  product: Product;
  price: number;
  variety: Broker_Variety;
  triggerPrice?: number | undefined;
  exchange: Exchange;
  strikePrice?: number | undefined;
  expiry?: number | undefined;
  optionType?: OptionType | undefined;
}

export interface MarginFromBrokerRequest_TradingAccount {
  accountId: string;
  brokerId: string;
}

export interface MarginFromBrokerResponse {
  totalMargin: number;
  brokerCharges?: number | undefined;
}

function createBaseBroker(): Broker {
  return {};
}

export const Broker = {
  encode(_: Broker, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Broker {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBroker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Broker {
    return {};
  },

  toJSON(_: Broker): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Broker>, I>>(base?: I): Broker {
    return Broker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Broker>, I>>(_: I): Broker {
    const message = createBaseBroker();
    return message;
  },
};

function createBaseOrders(): Orders {
  return { orders: [] };
}

export const Orders = {
  encode(message: Orders, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Orders {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrders();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orders.push(Order.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Orders {
    return { orders: globalThis.Array.isArray(object?.orders) ? object.orders.map((e: any) => Order.fromJSON(e)) : [] };
  },

  toJSON(message: Orders): unknown {
    const obj: any = {};
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Orders>, I>>(base?: I): Orders {
    return Orders.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Orders>, I>>(object: I): Orders {
    const message = createBaseOrders();
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrder(): Order {
  return {
    orderDate: 0,
    clientOrderId: "",
    orderId: undefined,
    orderType: 0,
    isBasket: false,
    basketId: undefined,
    batchId: undefined,
    brokerOrderType: 0,
    brokerVariety: 0,
    brokerOrderId: undefined,
    security: undefined,
    product: 0,
    transactionType: 0,
    validity: 0,
    exchangeOrderId: undefined,
    quantity: 0,
    price: 0,
    triggerPrice: undefined,
    disclosedQuantity: undefined,
    status: undefined,
    strategyGroup: undefined,
    created: undefined,
    exchangeTimestamp: undefined,
    message: undefined,
    filledQuantity: undefined,
    unfilledQuantity: undefined,
    averageTradedPrice: undefined,
    metadata: undefined,
    secondaryStatus: undefined,
    marketProtection: undefined,
    orderExecutionParams: undefined,
    orderExecutionMetadata: undefined,
    parentOrderId: undefined,
    immediateExecutePaperOrder: false,
  };
}

export const Order = {
  encode(message: Order, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.orderDate !== 0) {
      writer.uint32(2400).int64(message.orderDate);
    }
    if (message.clientOrderId !== "") {
      writer.uint32(10).string(message.clientOrderId);
    }
    if (message.orderId !== undefined) {
      writer.uint32(18).string(message.orderId);
    }
    if (message.orderType !== 0) {
      writer.uint32(80).int32(message.orderType);
    }
    if (message.isBasket !== false) {
      writer.uint32(120).bool(message.isBasket);
    }
    if (message.basketId !== undefined) {
      writer.uint32(226).string(message.basketId);
    }
    if (message.batchId !== undefined) {
      writer.uint32(218).string(message.batchId);
    }
    if (message.brokerOrderType !== 0) {
      writer.uint32(88).int32(message.brokerOrderType);
    }
    if (message.brokerVariety !== 0) {
      writer.uint32(168).int32(message.brokerVariety);
    }
    if (message.brokerOrderId !== undefined) {
      writer.uint32(26).string(message.brokerOrderId);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(50).fork()).ldelim();
    }
    if (message.product !== 0) {
      writer.uint32(112).int32(message.product);
    }
    if (message.transactionType !== 0) {
      writer.uint32(64).int32(message.transactionType);
    }
    if (message.validity !== 0) {
      writer.uint32(192).int32(message.validity);
    }
    if (message.exchangeOrderId !== undefined) {
      writer.uint32(34).string(message.exchangeOrderId);
    }
    if (message.quantity !== 0) {
      writer.uint32(96).int32(message.quantity);
    }
    if (message.price !== 0) {
      writer.uint32(128).int32(message.price);
    }
    if (message.triggerPrice !== undefined) {
      writer.uint32(144).int32(message.triggerPrice);
    }
    if (message.disclosedQuantity !== undefined) {
      writer.uint32(176).int32(message.disclosedQuantity);
    }
    if (message.status !== undefined) {
      writer.uint32(208).int32(message.status);
    }
    if (message.strategyGroup !== undefined) {
      writer.uint32(242).string(message.strategyGroup);
    }
    if (message.created !== undefined) {
      writer.uint32(256).int64(message.created);
    }
    if (message.exchangeTimestamp !== undefined) {
      writer.uint32(272).int64(message.exchangeTimestamp);
    }
    if (message.message !== undefined) {
      writer.uint32(290).string(message.message);
    }
    if (message.filledQuantity !== undefined) {
      writer.uint32(304).int32(message.filledQuantity);
    }
    if (message.unfilledQuantity !== undefined) {
      writer.uint32(320).int32(message.unfilledQuantity);
    }
    if (message.averageTradedPrice !== undefined) {
      writer.uint32(337).double(message.averageTradedPrice);
    }
    if (message.metadata !== undefined) {
      writer.uint32(354).string(message.metadata);
    }
    if (message.secondaryStatus !== undefined) {
      writer.uint32(800).int32(message.secondaryStatus);
    }
    if (message.marketProtection !== undefined) {
      writer.uint32(360).int32(message.marketProtection);
    }
    if (message.orderExecutionParams !== undefined) {
      OrderExecutionParams.encode(message.orderExecutionParams, writer.uint32(402).fork()).ldelim();
    }
    if (message.orderExecutionMetadata !== undefined) {
      OrderExecutionMetadata.encode(message.orderExecutionMetadata, writer.uint32(442).fork()).ldelim();
    }
    if (message.parentOrderId !== undefined) {
      writer.uint32(450).string(message.parentOrderId);
    }
    if (message.immediateExecutePaperOrder !== false) {
      writer.uint32(456).bool(message.immediateExecutePaperOrder);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Order {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 300:
          if (tag !== 2400) {
            break;
          }

          message.orderDate = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.clientOrderId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.orderType = reader.int32() as any;
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.isBasket = reader.bool();
          continue;
        case 28:
          if (tag !== 226) {
            break;
          }

          message.basketId = reader.string();
          continue;
        case 27:
          if (tag !== 218) {
            break;
          }

          message.batchId = reader.string();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.brokerOrderType = reader.int32() as any;
          continue;
        case 21:
          if (tag !== 168) {
            break;
          }

          message.brokerVariety = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerOrderId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 24:
          if (tag !== 192) {
            break;
          }

          message.validity = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.exchangeOrderId = reader.string();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.price = reader.int32();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.triggerPrice = reader.int32();
          continue;
        case 22:
          if (tag !== 176) {
            break;
          }

          message.disclosedQuantity = reader.int32();
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 30:
          if (tag !== 242) {
            break;
          }

          message.strategyGroup = reader.string();
          continue;
        case 32:
          if (tag !== 256) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 34:
          if (tag !== 272) {
            break;
          }

          message.exchangeTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 36:
          if (tag !== 290) {
            break;
          }

          message.message = reader.string();
          continue;
        case 38:
          if (tag !== 304) {
            break;
          }

          message.filledQuantity = reader.int32();
          continue;
        case 40:
          if (tag !== 320) {
            break;
          }

          message.unfilledQuantity = reader.int32();
          continue;
        case 42:
          if (tag !== 337) {
            break;
          }

          message.averageTradedPrice = reader.double();
          continue;
        case 44:
          if (tag !== 354) {
            break;
          }

          message.metadata = reader.string();
          continue;
        case 100:
          if (tag !== 800) {
            break;
          }

          message.secondaryStatus = reader.int32() as any;
          continue;
        case 45:
          if (tag !== 360) {
            break;
          }

          message.marketProtection = reader.int32();
          continue;
        case 50:
          if (tag !== 402) {
            break;
          }

          message.orderExecutionParams = OrderExecutionParams.decode(reader, reader.uint32());
          continue;
        case 55:
          if (tag !== 442) {
            break;
          }

          message.orderExecutionMetadata = OrderExecutionMetadata.decode(reader, reader.uint32());
          continue;
        case 56:
          if (tag !== 450) {
            break;
          }

          message.parentOrderId = reader.string();
          continue;
        case 57:
          if (tag !== 456) {
            break;
          }

          message.immediateExecutePaperOrder = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Order {
    return {
      orderDate: isSet(object.orderDate) ? globalThis.Number(object.orderDate) : 0,
      clientOrderId: isSet(object.clientOrderId) ? globalThis.String(object.clientOrderId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : undefined,
      orderType: isSet(object.orderType) ? orderTypeFromJSON(object.orderType) : 0,
      isBasket: isSet(object.isBasket) ? globalThis.Boolean(object.isBasket) : false,
      basketId: isSet(object.basketId) ? globalThis.String(object.basketId) : undefined,
      batchId: isSet(object.batchId) ? globalThis.String(object.batchId) : undefined,
      brokerOrderType: isSet(object.brokerOrderType) ? broker_OrderTypeFromJSON(object.brokerOrderType) : 0,
      brokerVariety: isSet(object.brokerVariety) ? broker_VarietyFromJSON(object.brokerVariety) : 0,
      brokerOrderId: isSet(object.brokerOrderId) ? globalThis.String(object.brokerOrderId) : undefined,
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      validity: isSet(object.validity) ? validityFromJSON(object.validity) : 0,
      exchangeOrderId: isSet(object.exchangeOrderId) ? globalThis.String(object.exchangeOrderId) : undefined,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      triggerPrice: isSet(object.triggerPrice) ? globalThis.Number(object.triggerPrice) : undefined,
      disclosedQuantity: isSet(object.disclosedQuantity) ? globalThis.Number(object.disclosedQuantity) : undefined,
      status: isSet(object.status) ? orderStatusFromJSON(object.status) : undefined,
      strategyGroup: isSet(object.strategyGroup) ? globalThis.String(object.strategyGroup) : undefined,
      created: isSet(object.created) ? globalThis.Number(object.created) : undefined,
      exchangeTimestamp: isSet(object.exchangeTimestamp) ? globalThis.Number(object.exchangeTimestamp) : undefined,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      filledQuantity: isSet(object.filledQuantity) ? globalThis.Number(object.filledQuantity) : undefined,
      unfilledQuantity: isSet(object.unfilledQuantity) ? globalThis.Number(object.unfilledQuantity) : undefined,
      averageTradedPrice: isSet(object.averageTradedPrice) ? globalThis.Number(object.averageTradedPrice) : undefined,
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : undefined,
      secondaryStatus: isSet(object.secondaryStatus) ? secondaryOrderStatusFromJSON(object.secondaryStatus) : undefined,
      marketProtection: isSet(object.marketProtection) ? globalThis.Number(object.marketProtection) : undefined,
      orderExecutionParams: isSet(object.orderExecutionParams)
        ? OrderExecutionParams.fromJSON(object.orderExecutionParams)
        : undefined,
      orderExecutionMetadata: isSet(object.orderExecutionMetadata)
        ? OrderExecutionMetadata.fromJSON(object.orderExecutionMetadata)
        : undefined,
      parentOrderId: isSet(object.parentOrderId) ? globalThis.String(object.parentOrderId) : undefined,
      immediateExecutePaperOrder: isSet(object.immediateExecutePaperOrder)
        ? globalThis.Boolean(object.immediateExecutePaperOrder)
        : false,
    };
  },

  toJSON(message: Order): unknown {
    const obj: any = {};
    if (message.orderDate !== 0) {
      obj.orderDate = Math.round(message.orderDate);
    }
    if (message.clientOrderId !== "") {
      obj.clientOrderId = message.clientOrderId;
    }
    if (message.orderId !== undefined) {
      obj.orderId = message.orderId;
    }
    if (message.orderType !== 0) {
      obj.orderType = orderTypeToJSON(message.orderType);
    }
    if (message.isBasket !== false) {
      obj.isBasket = message.isBasket;
    }
    if (message.basketId !== undefined) {
      obj.basketId = message.basketId;
    }
    if (message.batchId !== undefined) {
      obj.batchId = message.batchId;
    }
    if (message.brokerOrderType !== 0) {
      obj.brokerOrderType = broker_OrderTypeToJSON(message.brokerOrderType);
    }
    if (message.brokerVariety !== 0) {
      obj.brokerVariety = broker_VarietyToJSON(message.brokerVariety);
    }
    if (message.brokerOrderId !== undefined) {
      obj.brokerOrderId = message.brokerOrderId;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.validity !== 0) {
      obj.validity = validityToJSON(message.validity);
    }
    if (message.exchangeOrderId !== undefined) {
      obj.exchangeOrderId = message.exchangeOrderId;
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.price !== 0) {
      obj.price = Math.round(message.price);
    }
    if (message.triggerPrice !== undefined) {
      obj.triggerPrice = Math.round(message.triggerPrice);
    }
    if (message.disclosedQuantity !== undefined) {
      obj.disclosedQuantity = Math.round(message.disclosedQuantity);
    }
    if (message.status !== undefined) {
      obj.status = orderStatusToJSON(message.status);
    }
    if (message.strategyGroup !== undefined) {
      obj.strategyGroup = message.strategyGroup;
    }
    if (message.created !== undefined) {
      obj.created = Math.round(message.created);
    }
    if (message.exchangeTimestamp !== undefined) {
      obj.exchangeTimestamp = Math.round(message.exchangeTimestamp);
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.filledQuantity !== undefined) {
      obj.filledQuantity = Math.round(message.filledQuantity);
    }
    if (message.unfilledQuantity !== undefined) {
      obj.unfilledQuantity = Math.round(message.unfilledQuantity);
    }
    if (message.averageTradedPrice !== undefined) {
      obj.averageTradedPrice = message.averageTradedPrice;
    }
    if (message.metadata !== undefined) {
      obj.metadata = message.metadata;
    }
    if (message.secondaryStatus !== undefined) {
      obj.secondaryStatus = secondaryOrderStatusToJSON(message.secondaryStatus);
    }
    if (message.marketProtection !== undefined) {
      obj.marketProtection = Math.round(message.marketProtection);
    }
    if (message.orderExecutionParams !== undefined) {
      obj.orderExecutionParams = OrderExecutionParams.toJSON(message.orderExecutionParams);
    }
    if (message.orderExecutionMetadata !== undefined) {
      obj.orderExecutionMetadata = OrderExecutionMetadata.toJSON(message.orderExecutionMetadata);
    }
    if (message.parentOrderId !== undefined) {
      obj.parentOrderId = message.parentOrderId;
    }
    if (message.immediateExecutePaperOrder !== false) {
      obj.immediateExecutePaperOrder = message.immediateExecutePaperOrder;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Order>, I>>(base?: I): Order {
    return Order.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Order>, I>>(object: I): Order {
    const message = createBaseOrder();
    message.orderDate = object.orderDate ?? 0;
    message.clientOrderId = object.clientOrderId ?? "";
    message.orderId = object.orderId ?? undefined;
    message.orderType = object.orderType ?? 0;
    message.isBasket = object.isBasket ?? false;
    message.basketId = object.basketId ?? undefined;
    message.batchId = object.batchId ?? undefined;
    message.brokerOrderType = object.brokerOrderType ?? 0;
    message.brokerVariety = object.brokerVariety ?? 0;
    message.brokerOrderId = object.brokerOrderId ?? undefined;
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.product = object.product ?? 0;
    message.transactionType = object.transactionType ?? 0;
    message.validity = object.validity ?? 0;
    message.exchangeOrderId = object.exchangeOrderId ?? undefined;
    message.quantity = object.quantity ?? 0;
    message.price = object.price ?? 0;
    message.triggerPrice = object.triggerPrice ?? undefined;
    message.disclosedQuantity = object.disclosedQuantity ?? undefined;
    message.status = object.status ?? undefined;
    message.strategyGroup = object.strategyGroup ?? undefined;
    message.created = object.created ?? undefined;
    message.exchangeTimestamp = object.exchangeTimestamp ?? undefined;
    message.message = object.message ?? undefined;
    message.filledQuantity = object.filledQuantity ?? undefined;
    message.unfilledQuantity = object.unfilledQuantity ?? undefined;
    message.averageTradedPrice = object.averageTradedPrice ?? undefined;
    message.metadata = object.metadata ?? undefined;
    message.secondaryStatus = object.secondaryStatus ?? undefined;
    message.marketProtection = object.marketProtection ?? undefined;
    message.orderExecutionParams = (object.orderExecutionParams !== undefined && object.orderExecutionParams !== null)
      ? OrderExecutionParams.fromPartial(object.orderExecutionParams)
      : undefined;
    message.orderExecutionMetadata =
      (object.orderExecutionMetadata !== undefined && object.orderExecutionMetadata !== null)
        ? OrderExecutionMetadata.fromPartial(object.orderExecutionMetadata)
        : undefined;
    message.parentOrderId = object.parentOrderId ?? undefined;
    message.immediateExecutePaperOrder = object.immediateExecutePaperOrder ?? false;
    return message;
  },
};

function createBaseOrderExecutionParams(): OrderExecutionParams {
  return {
    trailStopLoss: undefined,
    icebergNumberOfLegs: undefined,
    icebergLegNumber: undefined,
    condition: undefined,
  };
}

export const OrderExecutionParams = {
  encode(message: OrderExecutionParams, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trailStopLoss !== undefined) {
      writer.uint32(24).bool(message.trailStopLoss);
    }
    if (message.icebergNumberOfLegs !== undefined) {
      writer.uint32(72).int32(message.icebergNumberOfLegs);
    }
    if (message.icebergLegNumber !== undefined) {
      writer.uint32(88).int32(message.icebergLegNumber);
    }
    if (message.condition !== undefined) {
      Condition.encode(message.condition, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderExecutionParams {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderExecutionParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          if (tag !== 24) {
            break;
          }

          message.trailStopLoss = reader.bool();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.icebergNumberOfLegs = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.icebergLegNumber = reader.int32();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.condition = Condition.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderExecutionParams {
    return {
      trailStopLoss: isSet(object.trailStopLoss) ? globalThis.Boolean(object.trailStopLoss) : undefined,
      icebergNumberOfLegs: isSet(object.icebergNumberOfLegs)
        ? globalThis.Number(object.icebergNumberOfLegs)
        : undefined,
      icebergLegNumber: isSet(object.icebergLegNumber) ? globalThis.Number(object.icebergLegNumber) : undefined,
      condition: isSet(object.condition) ? Condition.fromJSON(object.condition) : undefined,
    };
  },

  toJSON(message: OrderExecutionParams): unknown {
    const obj: any = {};
    if (message.trailStopLoss !== undefined) {
      obj.trailStopLoss = message.trailStopLoss;
    }
    if (message.icebergNumberOfLegs !== undefined) {
      obj.icebergNumberOfLegs = Math.round(message.icebergNumberOfLegs);
    }
    if (message.icebergLegNumber !== undefined) {
      obj.icebergLegNumber = Math.round(message.icebergLegNumber);
    }
    if (message.condition !== undefined) {
      obj.condition = Condition.toJSON(message.condition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderExecutionParams>, I>>(base?: I): OrderExecutionParams {
    return OrderExecutionParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderExecutionParams>, I>>(object: I): OrderExecutionParams {
    const message = createBaseOrderExecutionParams();
    message.trailStopLoss = object.trailStopLoss ?? undefined;
    message.icebergNumberOfLegs = object.icebergNumberOfLegs ?? undefined;
    message.icebergLegNumber = object.icebergLegNumber ?? undefined;
    message.condition = (object.condition !== undefined && object.condition !== null)
      ? Condition.fromPartial(object.condition)
      : undefined;
    return message;
  },
};

function createBaseOrderExecutionMetadata(): OrderExecutionMetadata {
  return { associatedAlertId: undefined };
}

export const OrderExecutionMetadata = {
  encode(message: OrderExecutionMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.associatedAlertId !== undefined) {
      writer.uint32(74).string(message.associatedAlertId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderExecutionMetadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderExecutionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 9:
          if (tag !== 74) {
            break;
          }

          message.associatedAlertId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderExecutionMetadata {
    return {
      associatedAlertId: isSet(object.associatedAlertId) ? globalThis.String(object.associatedAlertId) : undefined,
    };
  },

  toJSON(message: OrderExecutionMetadata): unknown {
    const obj: any = {};
    if (message.associatedAlertId !== undefined) {
      obj.associatedAlertId = message.associatedAlertId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderExecutionMetadata>, I>>(base?: I): OrderExecutionMetadata {
    return OrderExecutionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderExecutionMetadata>, I>>(object: I): OrderExecutionMetadata {
    const message = createBaseOrderExecutionMetadata();
    message.associatedAlertId = object.associatedAlertId ?? undefined;
    return message;
  },
};

function createBaseTrade(): Trade {
  return {
    tradeId: 0,
    orderId: 0,
    securityCode: "",
    product: 0,
    averagePrice: 0,
    quantity: 0,
    exchangeOrderId: 0,
    transactionType: 0,
    fillTimestamp: 0,
    orderTimestamp: 0,
    exchangeTimestamp: 0,
  };
}

export const Trade = {
  encode(message: Trade, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradeId !== 0) {
      writer.uint32(8).int64(message.tradeId);
    }
    if (message.orderId !== 0) {
      writer.uint32(16).int64(message.orderId);
    }
    if (message.securityCode !== "") {
      writer.uint32(26).string(message.securityCode);
    }
    if (message.product !== 0) {
      writer.uint32(32).int32(message.product);
    }
    if (message.averagePrice !== 0) {
      writer.uint32(41).double(message.averagePrice);
    }
    if (message.quantity !== 0) {
      writer.uint32(48).int32(message.quantity);
    }
    if (message.exchangeOrderId !== 0) {
      writer.uint32(56).int64(message.exchangeOrderId);
    }
    if (message.transactionType !== 0) {
      writer.uint32(64).int32(message.transactionType);
    }
    if (message.fillTimestamp !== 0) {
      writer.uint32(72).int64(message.fillTimestamp);
    }
    if (message.orderTimestamp !== 0) {
      writer.uint32(80).int64(message.orderTimestamp);
    }
    if (message.exchangeTimestamp !== 0) {
      writer.uint32(88).int64(message.exchangeTimestamp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Trade {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrade();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.tradeId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.orderId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.securityCode = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.averagePrice = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.exchangeOrderId = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.fillTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.orderTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.exchangeTimestamp = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Trade {
    return {
      tradeId: isSet(object.tradeId) ? globalThis.Number(object.tradeId) : 0,
      orderId: isSet(object.orderId) ? globalThis.Number(object.orderId) : 0,
      securityCode: isSet(object.securityCode) ? globalThis.String(object.securityCode) : "",
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      averagePrice: isSet(object.averagePrice) ? globalThis.Number(object.averagePrice) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      exchangeOrderId: isSet(object.exchangeOrderId) ? globalThis.Number(object.exchangeOrderId) : 0,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      fillTimestamp: isSet(object.fillTimestamp) ? globalThis.Number(object.fillTimestamp) : 0,
      orderTimestamp: isSet(object.orderTimestamp) ? globalThis.Number(object.orderTimestamp) : 0,
      exchangeTimestamp: isSet(object.exchangeTimestamp) ? globalThis.Number(object.exchangeTimestamp) : 0,
    };
  },

  toJSON(message: Trade): unknown {
    const obj: any = {};
    if (message.tradeId !== 0) {
      obj.tradeId = Math.round(message.tradeId);
    }
    if (message.orderId !== 0) {
      obj.orderId = Math.round(message.orderId);
    }
    if (message.securityCode !== "") {
      obj.securityCode = message.securityCode;
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.averagePrice !== 0) {
      obj.averagePrice = message.averagePrice;
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.exchangeOrderId !== 0) {
      obj.exchangeOrderId = Math.round(message.exchangeOrderId);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.fillTimestamp !== 0) {
      obj.fillTimestamp = Math.round(message.fillTimestamp);
    }
    if (message.orderTimestamp !== 0) {
      obj.orderTimestamp = Math.round(message.orderTimestamp);
    }
    if (message.exchangeTimestamp !== 0) {
      obj.exchangeTimestamp = Math.round(message.exchangeTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Trade>, I>>(base?: I): Trade {
    return Trade.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Trade>, I>>(object: I): Trade {
    const message = createBaseTrade();
    message.tradeId = object.tradeId ?? 0;
    message.orderId = object.orderId ?? 0;
    message.securityCode = object.securityCode ?? "";
    message.product = object.product ?? 0;
    message.averagePrice = object.averagePrice ?? 0;
    message.quantity = object.quantity ?? 0;
    message.exchangeOrderId = object.exchangeOrderId ?? 0;
    message.transactionType = object.transactionType ?? 0;
    message.fillTimestamp = object.fillTimestamp ?? 0;
    message.orderTimestamp = object.orderTimestamp ?? 0;
    message.exchangeTimestamp = object.exchangeTimestamp ?? 0;
    return message;
  },
};

function createBaseCalculateMarginResponse(): CalculateMarginResponse {
  return { totalMargin: 0, strategyName: "" };
}

export const CalculateMarginResponse = {
  encode(message: CalculateMarginResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.totalMargin !== 0) {
      writer.uint32(9).double(message.totalMargin);
    }
    if (message.strategyName !== "") {
      writer.uint32(18).string(message.strategyName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CalculateMarginResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalculateMarginResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.totalMargin = reader.double();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.strategyName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalculateMarginResponse {
    return {
      totalMargin: isSet(object.totalMargin) ? globalThis.Number(object.totalMargin) : 0,
      strategyName: isSet(object.strategyName) ? globalThis.String(object.strategyName) : "",
    };
  },

  toJSON(message: CalculateMarginResponse): unknown {
    const obj: any = {};
    if (message.totalMargin !== 0) {
      obj.totalMargin = message.totalMargin;
    }
    if (message.strategyName !== "") {
      obj.strategyName = message.strategyName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalculateMarginResponse>, I>>(base?: I): CalculateMarginResponse {
    return CalculateMarginResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalculateMarginResponse>, I>>(object: I): CalculateMarginResponse {
    const message = createBaseCalculateMarginResponse();
    message.totalMargin = object.totalMargin ?? 0;
    message.strategyName = object.strategyName ?? "";
    return message;
  },
};

function createBaseMarginFromBrokerRequest(): MarginFromBrokerRequest {
  return { orders: [], tradingAccount: undefined };
}

export const MarginFromBrokerRequest = {
  encode(message: MarginFromBrokerRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orders) {
      MarginFromBrokerRequest_Order.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.tradingAccount !== undefined) {
      MarginFromBrokerRequest_TradingAccount.encode(message.tradingAccount, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MarginFromBrokerRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarginFromBrokerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orders.push(MarginFromBrokerRequest_Order.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingAccount = MarginFromBrokerRequest_TradingAccount.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarginFromBrokerRequest {
    return {
      orders: globalThis.Array.isArray(object?.orders)
        ? object.orders.map((e: any) => MarginFromBrokerRequest_Order.fromJSON(e))
        : [],
      tradingAccount: isSet(object.tradingAccount)
        ? MarginFromBrokerRequest_TradingAccount.fromJSON(object.tradingAccount)
        : undefined,
    };
  },

  toJSON(message: MarginFromBrokerRequest): unknown {
    const obj: any = {};
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => MarginFromBrokerRequest_Order.toJSON(e));
    }
    if (message.tradingAccount !== undefined) {
      obj.tradingAccount = MarginFromBrokerRequest_TradingAccount.toJSON(message.tradingAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MarginFromBrokerRequest>, I>>(base?: I): MarginFromBrokerRequest {
    return MarginFromBrokerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarginFromBrokerRequest>, I>>(object: I): MarginFromBrokerRequest {
    const message = createBaseMarginFromBrokerRequest();
    message.orders = object.orders?.map((e) => MarginFromBrokerRequest_Order.fromPartial(e)) || [];
    message.tradingAccount = (object.tradingAccount !== undefined && object.tradingAccount !== null)
      ? MarginFromBrokerRequest_TradingAccount.fromPartial(object.tradingAccount)
      : undefined;
    return message;
  },
};

function createBaseMarginFromBrokerRequest_Order(): MarginFromBrokerRequest_Order {
  return {
    security: undefined,
    transactionType: 0,
    orderType: 0,
    position: 0,
    product: 0,
    price: 0,
    variety: 0,
    triggerPrice: undefined,
    exchange: 0,
    strikePrice: undefined,
    expiry: undefined,
    optionType: undefined,
  };
}

export const MarginFromBrokerRequest_Order = {
  encode(message: MarginFromBrokerRequest_Order, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.transactionType !== 0) {
      writer.uint32(16).int32(message.transactionType);
    }
    if (message.orderType !== 0) {
      writer.uint32(24).int32(message.orderType);
    }
    if (message.position !== 0) {
      writer.uint32(32).int32(message.position);
    }
    if (message.product !== 0) {
      writer.uint32(40).int32(message.product);
    }
    if (message.price !== 0) {
      writer.uint32(49).double(message.price);
    }
    if (message.variety !== 0) {
      writer.uint32(56).int32(message.variety);
    }
    if (message.triggerPrice !== undefined) {
      writer.uint32(64).int32(message.triggerPrice);
    }
    if (message.exchange !== 0) {
      writer.uint32(72).int32(message.exchange);
    }
    if (message.strikePrice !== undefined) {
      writer.uint32(80).int32(message.strikePrice);
    }
    if (message.expiry !== undefined) {
      writer.uint32(88).int64(message.expiry);
    }
    if (message.optionType !== undefined) {
      writer.uint32(96).int32(message.optionType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MarginFromBrokerRequest_Order {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarginFromBrokerRequest_Order();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.orderType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.position = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.price = reader.double();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.variety = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.triggerPrice = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.strikePrice = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarginFromBrokerRequest_Order {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      orderType: isSet(object.orderType) ? broker_OrderTypeFromJSON(object.orderType) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      variety: isSet(object.variety) ? broker_VarietyFromJSON(object.variety) : 0,
      triggerPrice: isSet(object.triggerPrice) ? globalThis.Number(object.triggerPrice) : undefined,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      strikePrice: isSet(object.strikePrice) ? globalThis.Number(object.strikePrice) : undefined,
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : undefined,
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : undefined,
    };
  },

  toJSON(message: MarginFromBrokerRequest_Order): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.orderType !== 0) {
      obj.orderType = broker_OrderTypeToJSON(message.orderType);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.price !== 0) {
      obj.price = message.price;
    }
    if (message.variety !== 0) {
      obj.variety = broker_VarietyToJSON(message.variety);
    }
    if (message.triggerPrice !== undefined) {
      obj.triggerPrice = Math.round(message.triggerPrice);
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.strikePrice !== undefined) {
      obj.strikePrice = Math.round(message.strikePrice);
    }
    if (message.expiry !== undefined) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MarginFromBrokerRequest_Order>, I>>(base?: I): MarginFromBrokerRequest_Order {
    return MarginFromBrokerRequest_Order.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarginFromBrokerRequest_Order>, I>>(
    object: I,
  ): MarginFromBrokerRequest_Order {
    const message = createBaseMarginFromBrokerRequest_Order();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.transactionType = object.transactionType ?? 0;
    message.orderType = object.orderType ?? 0;
    message.position = object.position ?? 0;
    message.product = object.product ?? 0;
    message.price = object.price ?? 0;
    message.variety = object.variety ?? 0;
    message.triggerPrice = object.triggerPrice ?? undefined;
    message.exchange = object.exchange ?? 0;
    message.strikePrice = object.strikePrice ?? undefined;
    message.expiry = object.expiry ?? undefined;
    message.optionType = object.optionType ?? undefined;
    return message;
  },
};

function createBaseMarginFromBrokerRequest_TradingAccount(): MarginFromBrokerRequest_TradingAccount {
  return { accountId: "", brokerId: "" };
}

export const MarginFromBrokerRequest_TradingAccount = {
  encode(message: MarginFromBrokerRequest_TradingAccount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.brokerId !== "") {
      writer.uint32(18).string(message.brokerId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MarginFromBrokerRequest_TradingAccount {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarginFromBrokerRequest_TradingAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.brokerId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarginFromBrokerRequest_TradingAccount {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      brokerId: isSet(object.brokerId) ? globalThis.String(object.brokerId) : "",
    };
  },

  toJSON(message: MarginFromBrokerRequest_TradingAccount): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.brokerId !== "") {
      obj.brokerId = message.brokerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MarginFromBrokerRequest_TradingAccount>, I>>(
    base?: I,
  ): MarginFromBrokerRequest_TradingAccount {
    return MarginFromBrokerRequest_TradingAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarginFromBrokerRequest_TradingAccount>, I>>(
    object: I,
  ): MarginFromBrokerRequest_TradingAccount {
    const message = createBaseMarginFromBrokerRequest_TradingAccount();
    message.accountId = object.accountId ?? "";
    message.brokerId = object.brokerId ?? "";
    return message;
  },
};

function createBaseMarginFromBrokerResponse(): MarginFromBrokerResponse {
  return { totalMargin: 0, brokerCharges: undefined };
}

export const MarginFromBrokerResponse = {
  encode(message: MarginFromBrokerResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.totalMargin !== 0) {
      writer.uint32(9).double(message.totalMargin);
    }
    if (message.brokerCharges !== undefined) {
      writer.uint32(17).double(message.brokerCharges);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MarginFromBrokerResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarginFromBrokerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.totalMargin = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.brokerCharges = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarginFromBrokerResponse {
    return {
      totalMargin: isSet(object.totalMargin) ? globalThis.Number(object.totalMargin) : 0,
      brokerCharges: isSet(object.brokerCharges) ? globalThis.Number(object.brokerCharges) : undefined,
    };
  },

  toJSON(message: MarginFromBrokerResponse): unknown {
    const obj: any = {};
    if (message.totalMargin !== 0) {
      obj.totalMargin = message.totalMargin;
    }
    if (message.brokerCharges !== undefined) {
      obj.brokerCharges = message.brokerCharges;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MarginFromBrokerResponse>, I>>(base?: I): MarginFromBrokerResponse {
    return MarginFromBrokerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarginFromBrokerResponse>, I>>(object: I): MarginFromBrokerResponse {
    const message = createBaseMarginFromBrokerResponse();
    message.totalMargin = object.totalMargin ?? 0;
    message.brokerCharges = object.brokerCharges ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
